import * as React from 'react'
import { OfferDetailsAgreements } from '@modules/offers/common/details/personal-data/offer-details-agreements'
import { useGastroCardProduct } from '@modules/offers/gastro-card-boost/details/use-gastro-card-product'

export const GastroCardDynamicAgreements = (): JSX.Element => {
  const gastroCardProduct = useGastroCardProduct('gastro_card_dynamic')

  return <OfferDetailsAgreements rulesUrl={gastroCardProduct?.urls?.rules || ''} />
}
